export default {
  description: '{{name}} in {{city}}. Officieel menu. Bespaar geld en bestel hier online.',
};
